<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-75">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>{{ statInspIcon }}</md-icon>
          </div>
        </md-card-header>

        <md-card-content>
          <form class="form-horizontal" action method="post">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-100">
                <md-field>
                  <label for="type">Item Type</label>
                  <md-select
                    v-model="form.statInspItemType"
                    @md-selected="onTypeChange()"
                    required
                  >
                    <md-option
                      v-for="type in statInspItemTypeOptions"
                      :key="type.id"
                      :value="type.id"
                      >{{ type.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <md-field>
                  <label for="type">Time Period</label>
                  <md-select
                    v-model="form.statInspItemTimePeriod"
                    @md-selected="onTimePeriodChange()"
                    required
                  >
                    <md-option
                      v-for="timePeriod in statInspItemTimePeriodOptions"
                      :key="timePeriod.id"
                      :value="timePeriod.id"
                      >{{ timePeriod.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <md-field>
                  <label>Reminder interval (in days)</label>
                  <md-input
                    v-model="form.reminderFrequencyInDays"
                    type="number"
                    required
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-100">
                <md-field>
                  <label>Decription</label>
                  <md-textarea
                    v-model="form.description"
                    md-autogrow
                    required
                  ></md-textarea>
                </md-field>
              </div>
            </div>
          </form>
        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button
            native-type="submit"
            @click.native.prevent="onSubmit"
            class="md-success md-sm"
            :disabled="hasSubmit"
            ><md-icon class="material-icons">check</md-icon>Submit</md-button
          >
          <md-button class="md-danger md-sm" @click="onCancel"
            ><md-icon class="material-icons">close</md-icon>Cancel</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-25"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      hasSubmit: false,
      form: {
        statInspId: this.$route.params.statInspId,
        statInspItemTimePeriod: 1,
        statInspItemType: 0,
        reminderFrequencyInDays: 1,
        description: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      statInspIcon: "stat-insp/icon",
      statInspItemTypeOptions: "stat-insp/statInspItemTypes",
      statInspItemTimePeriodOptions: "stat-insp/statInspItemTimePeriods"
    })
  },
  methods: {
    onTypeChange() {
      this.form.statInspItemTimePeriod =
        this.form.statInspItemType === 1 ? 1 : 5;
    },
    onTimePeriodChange() {
      this.SetReminderIntervalInDays();
    },
    SetReminderIntervalInDays() {
      this.form.reminderFrequencyInDays = this.statInspItemTimePeriodOptions.find(
        timePeriod => timePeriod.id === this.form.statInspItemTimePeriod
      ).intervalInDays;
    },
    onCancel() {
      this.hasSubmit = false;
      this.$router.go(-1);
    },
    onSubmit() {
      this.hasSubmit = true;
      this.$store
        .dispatch("stat-insp/createStatInspItem", {
          statInspItem: this.form
        })
        .then(() => {
          this.$router.push({
            name: "Statutory Inspection",
            params: { statInspId: this.$route.params.statInspId }
          });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status >= 400 && error.response.status < 500) {
            // handle validation error
            if (error.response.data.errors != undefined) {
              let validationErrorDictionary = error.response.data.errors;
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  errors.push("- " + validationErrorDictionary[fieldName]);
                }
              }
            } else {
              errors.push(error.response.data);
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    }
  }
};
</script>

<style></style>
